import { atom } from 'recoil';
import type { ConnectorPatientManifest } from '~/domain/persistence/ConnectorPatientManifest';

/**
 * The connector identity of the currently loaded patient, published by the
 * viewer-side open loader just before the environment initializes (so it is
 * readable when the {@link PatientSession} is created) and cleared by
 * {@link useUnloadPatient}.
 *
 * Null whenever the loaded data has no connector backing (local files,
 * legacy-connector sessions) — the session then has no persistence refs and
 * database saving is unavailable.
 */
export const connectorPatientManifestState =
    atom<ConnectorPatientManifest | null>({
        key: 'connectorPatientManifest',
        default: null,
    });
